// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import {
    SOCIAL_MEDIA_LINK_LIST_CLASS_NAME
} from "../../../../core/constants/className";
import {
    DiscordLogo,
    FacebookLogo,
    GitHubLogo,
    LinkedInLogo,
    TwitterLogo
} from "../../../assets/logos";
import "./SocialMediaLinkList.scss";

export interface SocialMediaLinkListProps {
    readonly className ?: string;
    readonly discordUrl ?: string;
    readonly facebookUrl ?: string;
    readonly githubUrl ?: string;
    readonly linkedinUrl ?: string;
    readonly twitterUrl ?: string;
}

export function SocialMediaLinkList (props: SocialMediaLinkListProps) {
    const className = props?.className;
    const discordUrl = props?.discordUrl;
    const facebookUrl = props?.facebookUrl;
    const githubUrl = props?.githubUrl;
    const linkedinUrl = props?.linkedinUrl;
    const twitterUrl = props?.twitterUrl;
    return (
        <div className={
            SOCIAL_MEDIA_LINK_LIST_CLASS_NAME
            + (className? ` ${className}` : '')
        }>
            {discordUrl ? <a href={discordUrl} target="_blank" rel="noreferrer"><DiscordLogo /></a> : null}
            {facebookUrl ? <a href={facebookUrl} target="_blank" rel="noreferrer"><FacebookLogo /></a> : null}
            {githubUrl ? <a href={githubUrl} target="_blank" rel="noreferrer"><GitHubLogo /></a> : null}
            {linkedinUrl ? <a href={linkedinUrl} target="_blank" rel="noreferrer"><LinkedInLogo /></a> : null}
            {twitterUrl ? <a href={twitterUrl} target="_blank" rel="noreferrer"><TwitterLogo /></a> : null}
        </div>
    );
}
